export default {"src":"/_next/static/media/re-logo-white-shadow.ecea0e76.svg","height":145,"width":211,"blurWidth":0,"blurHeight":0};